import GenericDB from './generic-db';

export default class AppointmentsDB extends GenericDB {
  constructor() {
    super('appointments');
  }

  // Here you can extend AppointmentsDB with custom methods
}
